import { useLocation, useRootStore } from '@yarmill/utils';
import { Location } from 'history';
import { getDefaultMainRoute } from './utils';

export function useDefaultMainRoute(): string {
  const rootStore = useRootStore();
  const location = useLocation();
  return getDefaultMainRoute(rootStore, location as Location);
}
